/**
 * iter45 — Extracted from LeagueDashboard.jsx.
 *
 * Renders the LEADERBOARD tab body: leaderboard table only.
 * iter86.96 (One UI Phase 2): DramaMeter + Dark Horses ELIMINATED
 * (operator call); Movers + Eliminated moved into the LeagueIntelStrip.
 * iter86.99: "The Ride" rank chart removed here — it lives on the
 * Recap page (which always rendered it).
 * iter87.23: "Rivalry Champion" banner deleted (operator call). The
 * banner labelled the tournament-winning team as the "Rivalry Champion",
 * which was misleading — Rivalry Champion should mean the crewmate at
 * the top of the leaderboard, not the sport team that won the trophy.
 * Removed the confused banner entirely; the top-of-table crewmate row
 * already carries the podium halo and gold "1st" ribbon.
 */
import LeaderboardTable from "./LeaderboardTable";

export default function LeaderboardView({ board, tournament, meId }) {
    return <LeaderboardTable rows={board} meId={meId} tournament={tournament} />;
}
